"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotChannelType = void 0;
/**
 * @author Qianhao Dong <qidon@microsoft.com>
 */
var BotChannelType;
(function (BotChannelType) {
    BotChannelType["MicrosoftTeams"] = "msteams";
    BotChannelType["M365Extensions"] = "m365extensions";
})(BotChannelType || (exports.BotChannelType = BotChannelType = {}));
//# sourceMappingURL=IBotRegistration.js.map